const air = require('./airmee.svg');
const apotekHjartat = require('./ApotekHjartat.svg');
const asd = require('./asendia.png');
const babyshop = require('./babyshop.png');
const bst = require('./best.svg');
const brn = require('./brn.svg');
const budbee = require('./budbee.png');
const caliroots = require('./caliroots.png');
const dbs = require('./dbs.png');
const depost = require('./depost.svg');
const dhl = require('./dhl.svg');
const dhlExpress = require('./DhlExpress.svg');
const dhlPaket = require('./DhlPaket.svg');
const dhlServicePoint = require('./DhlServicepoint.svg');
const fdx = require('./fedex.svg');
const gls = require('./gls.svg');
const hje = require('./hje.svg');
const isb = require('./instabox.svg');
const kronans = require('./kronans.png');
const lekmerSe = require('./lekmerSe.svg');
const pnl = require('./pnl.svg');
const posti = require('./posti.svg');
const ups = require('./ups.svg');
const uropenn = require('./uropenn.svg');
const airGreen = require('./airmee-green.svg');

export default {
  air,
  apotekHjartat,
  asd,
  babyshop,
  bst,
  brn,
  budbee,
  caliroots,
  dbs,
  depost,
  dhl,
  dhlExpress,
  dhlPaket,
  dhlServicePoint,
  fdx,
  gls,
  hje,
  isb,
  kronans,
  lekmerSe,
  pnl,
  posti,
  ups,
  uropenn,
  airGreen,
};
